import { Breakpoint, Scroll, Touch, Context } from '@modules';
import { AbstractDispatcher } from '@abstracts';

export default class AbstractMain extends AbstractDispatcher {
  static _instance;

  constructor(options) {
    super();

    // Singleton
    if (AbstractMain._instance) {
      throw new Error(
        'Error: Use AbstractMain.instance or Main.instance instead of new.'
      );
    }
    AbstractMain._instance = this;

    // modules
    new Context(options);
    new Breakpoint();
    new Scroll();
    new Touch();

    document.addEventListener(
      'visibilitychange',
      this.onVisibilityChange,
      false
    );
  }

  /**
   * get singleton instance
   * @returns { AbstractMain } instance's AbstractMain
   */
  static get instance() {
    return AbstractMain._instance;
  }
}
